import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export const useRouteAuth = () => {
  const location = useLocation();
  const { checkToken, token } = useAuth();

  useEffect(() => {
    // Check token on each route change if token exists
    if (token) {
      checkToken();
    }
  }, [location.pathname, token, checkToken]);
};